import { fetch } from '@utils/utils';
import * as T from '@modules/trips/_tripsTypes';

export const getTrip = ({ addError }) => async (id: string): Promise<T.Trip> => {
  try {
    const response: any = await fetch(`/metropolis/api/cl/trip/${id}`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json: T.Trip = await response.json();

    return json;
  } catch (err) {
    addError(err.message);
    return {};
  }
};

export const putTrip = ({ addError, addSuccess }) => async (body: T.Trip): Promise<T.Trip | null> => {
  try {
    const response: any = await fetch(`/metropolis/api/cl/trip/${body.id}`, {
      method: 'PUT',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(body)
    });

    if (response.ok) {
      addSuccess('Jízda byla úspěšne uložena');
      const json: T.Trip = await response.json();
      return json;
    } else {
      addError('Jízda nebyla uložena');
      return null;
    }
  } catch (err) {
    addError(err.message);
    return null;
  }
};



// WEBPACK FOOTER //
// ./src/modules/trips/_tripsActions.ts